export default __webpack_public_path__ + "static/media/bahan-alam.97fc12e5.png";